import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function PhotoUpload({ workOrderId, phase, onUploaded, label }) {
  const fileRef = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("work_order_id", workOrderId); fd.append("phase", phase); fd.append("description", "");
    try {
      await api.post("/upload/photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Photo uploaded"); onUploaded && onUploaded();
    } catch (err) { toast.error("Upload failed"); }
    setBusy(false); if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`photo-input-${phase}`} />
      <Button data-testid={`upload-photo-${phase}`} variant="outline" size="sm" disabled={busy} onClick={() => fileRef.current?.click()}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Camera className="w-4 h-4 mr-1" /> {label || `Add ${phase}`}</>}
      </Button>
    </>
  );
}
